import {
  HTTP_DISPATCH,
  HTTP_BUSY,
  HTTP_SUCCESS,
  HTTP_FAILURE
} from "./actions";

export const httpMiddleware = config => store => next => action => {
  if (action.type === HTTP_DISPATCH) {
    var headers = new Headers();

    if (action.payload) {
      headers.set("Content-Type", "application/json");
    }

    const url =
      action.url.indexOf("http") >= 0 ? action.url : config.apiUrl + action.url;

    const args = {
      method: action.method,
      body: action.payload ? JSON.stringify(action.payload) : action.body,
      headers: headers,
      message: action.message
    };

    store.dispatch({ type: HTTP_BUSY });

    fetch(url, args)
      .then(r => {
        console.log("r", r);
        action.cb(r);
        store.dispatch({
          type: HTTP_SUCCESS,
          status: r.status,
          success: r.status >= 200 && r.status <= 300,
          url: r.headers.get("Location")
        });
      })
      .catch(ex => store.dispatch({ type: HTTP_FAILURE, error: ex }));
  } else {
    return next(action);
  }
};
